import React from 'react';
var ContactVisibility = React.createContext({
    contactPopup: {
        contactIsVisible: false,
        onHidePopup: function () { },
        onShowPopup: function () { },
    }
});
export default ContactVisibility;
